import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save, Gift } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { ImageUploader } from "@/components/ImageUploader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function AdminDailyBonus() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/daily-bonus").then((r) =>
      setForm({ image_path: r.data.image_path || null, cta_text: r.data.cta_text || "", cta_url: r.data.cta_url || "" })
    );
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/daily-bonus", form);
      toast.success("Bonus del giorno aggiornato");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  if (!form) return <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-green-500" /></div>;

  return (
    <div className="space-y-5">
      <div>
        <h2 className="flex items-center gap-2 font-display text-2xl font-extrabold uppercase text-zinc-950">
          <Gift className="h-6 w-6 text-green-500" /> Bonus del giorno — "Trova la carota"
        </h2>
        <p className="text-sm text-zinc-500">Imposta la locandina e la CTA mostrate a chi trova il bonus. Puoi cambiarle ogni giorno.</p>
      </div>
      <div className="max-w-lg space-y-4 rounded-2xl border border-slate-200 bg-white p-5">
        <ImageUploader label="Locandina bonus (immagine)" value={form.image_path} onChange={(v) => setForm({ ...form, image_path: v })} testId="daily-bonus-image" />
        <div className="space-y-1.5">
          <Label>Testo bottone (CTA)</Label>
          <Input data-testid="daily-bonus-cta-text" value={form.cta_text} onChange={(e) => setForm({ ...form, cta_text: e.target.value })} placeholder="Es. Scopri il bonus" className="rounded-xl" />
        </div>
        <div className="space-y-1.5">
          <Label>URL destinazione bottone</Label>
          <Input data-testid="daily-bonus-cta-url" value={form.cta_url} onChange={(e) => setForm({ ...form, cta_url: e.target.value })} placeholder="https://..." className="rounded-xl" />
        </div>
        <Button data-testid="daily-bonus-save" onClick={save} disabled={saving} className="w-full rounded-full bg-zinc-950 font-bold text-green-400 hover:bg-zinc-800">
          <Save className="mr-1 h-4 w-4" /> {saving ? "Salvataggio..." : "Salva bonus del giorno"}
        </Button>
      </div>
    </div>
  );
}
